"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LogoAmex: function() {
        return _logoamexsvg.default;
    },
    LogoCergea: function() {
        return _logocergeasvg.default;
    },
    LogoCollinson: function() {
        return _logocollinsonsvg.default;
    },
    LogoCollinsonGray: function() {
        return _collinsonlogograysvg.default;
    },
    LogoHSBC: function() {
        return _logohsbcsvg.default;
    },
    LogoHeaderCollinson: function() {
        return _logoheadercollinsonsvg.default;
    },
    LogoHeaderCollinsonBlue: function() {
        return _logoheadercollinsonbluesvg.default;
    },
    LogoLK: function() {
        return _logoloungekeysvg.default;
    },
    LogoMastercard: function() {
        return _logomastercardsvg.default;
    },
    LogoPP: function() {
        return _logoprioritypasssvg.default;
    },
    LogoPartnerPortal: function() {
        return _logopartnerportalsvg.default;
    }
});
var _logoamexsvg = /*#__PURE__*/ _interop_require_default(require("./logo-amex.svg"));
var _logocergeasvg = /*#__PURE__*/ _interop_require_default(require("./logo-cergea.svg"));
var _logohsbcsvg = /*#__PURE__*/ _interop_require_default(require("./logo-hsbc.svg"));
var _logoprioritypasssvg = /*#__PURE__*/ _interop_require_default(require("./logo-prioritypass.svg"));
var _logoloungekeysvg = /*#__PURE__*/ _interop_require_default(require("./logo-loungekey.svg"));
var _logomastercardsvg = /*#__PURE__*/ _interop_require_default(require("./logo-mastercard.svg"));
var _logocollinsonsvg = /*#__PURE__*/ _interop_require_default(require("./logo-collinson.svg"));
var _logoheadercollinsonsvg = /*#__PURE__*/ _interop_require_default(require("./logo-header-collinson.svg"));
var _logoheadercollinsonbluesvg = /*#__PURE__*/ _interop_require_default(require("./logo-header-collinson-blue.svg"));
var _logopartnerportalsvg = /*#__PURE__*/ _interop_require_default(require("./logo-partnerportal.svg"));
var _collinsonlogograysvg = /*#__PURE__*/ _interop_require_default(require("./collinson-logo-gray.svg"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
